import React, { useContext, useRef } from 'react';

import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from "@material-ui/core/MenuItem";
import ListSubheader from '@material-ui/core/ListSubheader';
import { DropdownContext } from '../utils/constants';
import Select from '@material-ui/core/Select';

const isObject = (value) => {
    return value && typeof value === 'object' && value.constructor === Object;
};

const DropdownValue = (key, value) => {
    return (
        <MenuItem key={key} value={key}>
            {value}
        </MenuItem>
    );
}

export default function DropdownSelect({ dropdownName, dropdown, variant, fullWidth, size, labelId, label, controlClass, selectClass, ...props }) {
    const { dropdowns } = useContext(DropdownContext);
    const labelRef = useRef();
    const labelWidth = labelRef.current ? labelRef.current.clientWidth : 0

    if (dropdownName) {
        dropdown = dropdowns[dropdownName] || {};
    }

    return (
        
        <FormControl
            className={controlClass}
            variant={variant}
            size={size}
            fullWidth={fullWidth}
        >
            <InputLabel ref={labelRef} id={labelId}>{label}</InputLabel>
            <Select
                labelId={labelId}
                labelWidth={labelWidth}
                className={selectClass}
                {...props}
            >
                {Object.keys(dropdown).map((key) => {
                    let value = dropdown[key];
                    if (isObject(value)) {
                        return Object.keys(value).map((innerKey, index) => {
                            let innerValue = value[innerKey];
                            if (isObject(innerValue)) {
                                return (
                                    [
                                        <ListSubheader key={innerKey} label={innerKey} disableSticky>
                                            {index === 0 && key}
                                            <ListSubheader component='div' key={innerKey} label={innerKey} disableSticky>
                                                {innerKey}
                                            </ListSubheader>
                                        </ListSubheader>,
                                        Object.keys(innerValue).map((key) => DropdownValue(key, innerValue[key]))
                                    ]
                                )
                            } else {
                                return DropdownValue(innerKey, innerValue);
                            }
                        })
                    } else {
                        return DropdownValue(key, value);
                    }
                })}
            </Select>
        </FormControl>
    );
}